import React, { useContext } from "react";
import { FormLayout, Select, TextField } from "@shopify/polaris";
import PropsType from "prop-types";

// import lib
import { baseHelper } from "lib/helpers";
import { PrivateContext } from "lib/context";

//  import constant
import constant from "lib/constant/constant";
import { useLocation, useNavigate } from "react-router-dom";

const MoreFilters = (props) => {
  const { taggedWith, setTaggedWith, selectedFilter, setSelectedFilter, filterOptions } = props;
  const { cms } = useContext(PrivateContext);
  const location = useLocation();
  const navigate = useNavigate();

  const handleSelectChange = (value) => {
    setSelectedFilter(value);
    baseHelper.setUrl(location, navigate, { list_filter: value });
  };

  const handleTaggedWithChange = (value) => {
    setTaggedWith(value);
    baseHelper.setUrl(location, navigate, { list_search: value });
  };

  return (
    <>
      <FormLayout>
        <Select
          label={`${cms("label.allOrder")}:`}
          value={selectedFilter || ""}
          placeholder={cms("placeholder.select") || cms("label.select") || constant.SELECT}
          onChange={handleSelectChange}
          options={filterOptions}
        />
        {(selectedFilter && (
          <TextField label={cms("label.like")} value={taggedWith} onChange={handleTaggedWithChange} />
        )) ||
          null}
      </FormLayout>
    </>
  );
};
MoreFilters.defaultProps = {
  setTaggedWith: () => {},
  taggedWith: "",
  setSelectedFilter: () => {},
  selectedFilter: "",
};

MoreFilters.propTypes = {
  setTaggedWith: PropsType.func,
  taggedWith: PropsType.string,
  setSelectedFilter: PropsType.func,
  selectedFilter: PropsType.string,
};
export default MoreFilters;
